// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 899px) {\n.map-overflow .map-tooltip {\n    display: none;\n}\n}\nhtml[dir] body {\n  background-color: transparent;\n}\nhtml, body {\n  overflow: hidden;\n  height: 100%;\n  max-height: 100%;\n}\nhtml[dir], [dir] body {\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
